export class KnowledgeBase {

    public id: string = "0";
    public name: string;
    public html: string;

    constructor() { }
}